import styles from "./index.module.css";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJs,
  CategoryScale,
  BarElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import { getCertificateGraphCreation, getSalePaymnets } from "../../redux/features/dashboard/dashboardService";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import { selectCertificateGraphData } from "../../redux/features/dashboard/dashboardSlice";
import { getActiveCertificateEntities } from "../../redux/features/certificateEntity/certificateEntityService";
import { selectActiveCertificateList } from "../../redux/features/certificateEntity/certificateEntitySlice";
import { getAllActiveCourses } from "../../redux/features/course/courseService";
import UpdatedDropdown from "../UpdatedDropdown";
import FilterDropdown from "../FilterDropdown";

ChartJs.register(
  CategoryScale,
  BarElement,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const certificateStatus = [
  { id: '1', name: 'Pending' },
  { id: '2', name: 'Verified' },
  { id: '3', name: 'Printed' },
  { id: '4', name: 'Issued' },
  { id: '5', name: 'ReIssued' },
  { id: '6', name: 'Cancelled' }];

const BarChart = ({ chartTitle }) => {
  const dispatch = useDispatch();
  const entityDropdownRef = useRef(null);
  const courseDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);

  const { status, data } = useSelector(selectCertificateGraphData);
  const { status: entityStatus, data: activeCertificateEntities } = useSelector(selectActiveCertificateList);

  const [selectedCourse, setSelectedCourse] = useState({
    id: '',
    name: ''
  });
  const [selectedStatus, setSelectedStatus] = useState({
    id: '',
    name: ''
  });
  const [entityCourses, setEntityCourses] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState({
    id: '',
    name: ''
  });

    const fetchGraphData = useCallback(
          (filters = {}) => {
              const params = {
                  course_code: selectedCourse.id,
                  certificate_status: selectedStatus.name,
                  // certificate_entity_code: selectedEntity.id,
                  ...filters,
              };
              dispatch(getCertificateGraphCreation(params));
          },
          [dispatch, selectedStatus]
      );
      
  useEffect(() => {
    fetchGraphData();
  }, [fetchGraphData]);

  useEffect(() => {
    dispatch(getActiveCertificateEntities());
  }, [dispatch]);

  const handleSelectEntity = async (option) => {
    setEntityCourses([]);
    setSelectedCourse({ id: '', name: '' });
    setSelectedEntity({
      id: option.code,
      name: option.name
    });
    const response = await dispatch(getAllActiveCourses({ entityId: option.id })).unwrap();
    setEntityCourses(response);
  };

  const handleSelect = (option) => {
    setSelectedCourse({
      id: option.code,
      name: option.name
    });
  };

      const handleType = async (option) => {
          setSelectedStatus({
              id: option.id,
              name: option.name,
          });
      };
  const getDayName = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { weekday: 'short' });
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: true,
        },
        ticks: {
          stepSize: 100,
        },
      },
    },
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardTopic}>
        <p className={styles.title}>{chartTitle}</p>
      </div>
        <div className={styles.searchSec}>
                                  {/* <FilterDropdown
                                      ref={entityDropdownRef}
                                      options={activeCertificateEntities}
                                      placeholder="Select an Entity"
                                      onSelect={handleSelectEntity}
                                      value={selectedEntity.name}
                                  /> */}
                                  {/* <FilterDropdown
                                      ref={courseDropdownRef}
                                      options={entityCourses}
                                      placeholder="Select a Course"
                                      onSelect={handleSelect}
                                      value={selectedCourse.name}
                                  /> */}
                                  <FilterDropdown
                                      ref={statusDropdownRef}
                                      options={certificateStatus}
                                      placeholder='Select a Type'
                                      onSelect={handleType}
                                      value={selectedStatus.name}
                                  />
                      </div>
      <div className={styles.barChart}>
        <Bar
          options={options}
          data={{
            labels: data?.map((item) => (item.month)) || [],
            datasets: [
              {
                label: "Certificates",
                backgroundColor: "#df771c",
                barThickness: 20,
                borderRadius: 2,
                borderSkipped: false,
                data: data?.map((item) => Number(item.certificate_count)) || [],
              },
            ],
          }}
        />
      </div>
    </div>
  );
};

export default BarChart;